/* eslint-disable sort-keys */
// Line heights don't seem to resolve nicely here so have included them as rem values with theme reference in comments
// Might be Chakra <1.0 issue...
export default {
    h1: {
        fontSize: "h1",
        fontWeight: "bold",
        mb: "6",
        lineHeight: "2.875rem" // 11.5
    },
    h2: {
        fontSize: "h2",
        fontWeight: "bold",
        mb: "4",
        lineHeight: "2.625rem" //10.5
    },
    h3: {
        fontSize: "h3",
        fontWeight: "bold",
        mb: "4",
        lineHeight: "1.875rem" // 7.5
    },
    h4: {
        fontSize: "h4",
        fontWeight: "bold",
        mb: "2",
        lineHeight: "1.25rem" // 5
    },
    h5: {
        fontSize: "h5",
        fontWeight: "medium",
        mb: "2",
        lineHeight: "1.25rem" // 5
    },
    p1: {
        fontSize: "p1",
        fontWeight: "regular",
        mb: "2",
        lineHeight: "1.5rem" // 6
    },
    p2: {
        fontSize: "p2",
        fontWeight: "regular",
        mb: "2",
        lineHeight: "1.375" // 5.5
    },
    p3: {
        fontSize: "p3",
        fontWeight: "regular",
        mb: "2",
        lineHeight: "1.125rem" // 4.5
    },
    p3normal: {
        fontWeight: "bold", 
        lineHeight: "normal",
        fontSize: "p3"
    },
    p4: {
        fontSize: "p4",
        fontWeight: "regular",
        mb: "2",
        lineHeight: "1rem" // 4 
    },
    notificationTitle: ({
        fontSize:"xs",
        lineHeight:"1.5",
    }),
    taskItemBody: {
        fontSize: "xs", 
        color: "gray.400"
    },
    taskItemTime: {
        fontSize: "xs", 
        color: "gray.300"
    }
};
